import GeneralButtonComponent from "../../../components/button/GeneralButtonComponent"
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import ImageAsync from "../../../components/native/ImageAsync";

const FoodCardItem = ({ name, action = () => { }, img, link = '' }) => {

    const navigate = useNavigate();


    return (
        <div className="w-full rounded border flex justify-between items-center p-2 mb-4 mt-4">
            <div className="flex items-center">
                <ImageAsync className="rounded-md" src={"/assets/img/svg/" + img} alt={name} width={'94px'} height={'94px'} />
                <span className="ml-4" style={{ fontSize: '16px' }}>{name}</span>
            </div>

            <span>
                <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6' click={() => {
                    navigate('/room-service/detail/1')
                }}
                    bgcolor='#67BAAF'>Detalle</GeneralButtonComponent>
            </span>
        </div>
    )
}

FoodCardItem.propTypes = {
    name: PropTypes.string,
    action: PropTypes.func,
    img: PropTypes.string,
    link: PropTypes.string
}

export default FoodCardItem
